import { SkeletonLoading } from 'app/common/templates-next/page-template'
import PlainLabel from 'app/common/ui-next/plain-label'
import { PlainColumn, PlainColumns } from 'app/common/ui/PlainGrid'
import PlainLink from 'app/common/ui-next/plain-link'
import classNames from 'classnames/bind'
import { FoodSupplierInfoType } from 'app/dataTypes/cafeteria/compensation/foodSuppliers'
import styles from '../CompensationInfo.scss'


const cx = classNames.bind(styles)

type Props = {
  supplierInfo?: FoodSupplierInfoType
  loading: boolean
  link: string
}
export const FoodSupplierInfo = ({ supplierInfo, loading, link }: Props) => {
  return (
    <PlainColumns className={cx(styles.row, styles.supplierInfo)}>
      <PlainLabel id="supplier" className={styles.label}>
        {'Поставщик питания: '}
      </PlainLabel>

      {loading
        ? <PlainColumn div={6}>
          <SkeletonLoading rows={1} className={styles.skeleton} />
        </PlainColumn>
        : <PlainLabel id="supplierInfo" className={styles.itemInfo}>
          {supplierInfo?.title}
        </PlainLabel>}

      <PlainLink to={link} className={styles.button}>{'Список поставщиков питания'}</PlainLink>
    </PlainColumns>
  )
}
